const capitalize = ([first,...rest]) => first.toUpperCase() + rest.join('').toLowerCase();

export const showToast = (dispatch, message, toastType, title) => {
   dispatch({
      title: title ? capitalize(title) : '',
      toastType: toastType,
      message: message,
   });
};

export const ToastType = {
   ERROR: 'ERROR',
   INFO: 'INFO',
   SUCCESS: 'SUCCESS',
   WARNING: 'WARNING',
};

export function checkStatus(status) {
   switch (status) {
       case 'FINISHED':
           return "FINALIZADO";
       case 'STARTED':
           return "EMPEZANDO";
       case 'WAITING':
           return "ESPERANDO";
       case 'ERROR':
           return "ERROR";
       case 'QUIT':
            return "CANCELADO"
       case 'ACCEPTED':
            return "ACEPTADO"
       case 'FAIL_SAVE_CONSULTATION':
            return "ERROR AL GUARDAR LA CONSULTA";
       case 'LINK':
            return "LINK";
       default:
           return "DESCONOCIDO";
   }
}

export function processEmail(email) {
    if (email.includes('#')) {
        let parts = email.split('#');
        return parts[0];
    }
    return email;
}

export function validatePhone(phone) {
    if (!phone || phone === undefined) return false;
    
    const phoneClear = phone.toString().replace(/[^0-9]/g, '');
    
    return phoneClear.length > 9;   
}